// extracted by mini-css-extract-plugin
export default {"container":"treatment-path_container__pdupt","button":"treatment-path_button__+htzy"};